/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ClearMCPRegistryCacheSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ClearMCPRegistryCacheSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ClearMCPRegistryCacheSecurity = {
  option1?: ClearMCPRegistryCacheSecurityOption1 | undefined;
  option2?: ClearMCPRegistryCacheSecurityOption2 | undefined;
};

export type ClearMCPRegistryCacheRequest = {
  /**
   * The registry to clear cache for
   */
  registryId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ClearMCPRegistryCacheSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ClearMCPRegistryCacheSecurityOption1$outboundSchema: z.ZodMiniType<
  ClearMCPRegistryCacheSecurityOption1$Outbound,
  ClearMCPRegistryCacheSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function clearMCPRegistryCacheSecurityOption1ToJSON(
  clearMCPRegistryCacheSecurityOption1: ClearMCPRegistryCacheSecurityOption1,
): string {
  return JSON.stringify(
    ClearMCPRegistryCacheSecurityOption1$outboundSchema.parse(
      clearMCPRegistryCacheSecurityOption1,
    ),
  );
}

/** @internal */
export type ClearMCPRegistryCacheSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ClearMCPRegistryCacheSecurityOption2$outboundSchema: z.ZodMiniType<
  ClearMCPRegistryCacheSecurityOption2$Outbound,
  ClearMCPRegistryCacheSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function clearMCPRegistryCacheSecurityOption2ToJSON(
  clearMCPRegistryCacheSecurityOption2: ClearMCPRegistryCacheSecurityOption2,
): string {
  return JSON.stringify(
    ClearMCPRegistryCacheSecurityOption2$outboundSchema.parse(
      clearMCPRegistryCacheSecurityOption2,
    ),
  );
}

/** @internal */
export type ClearMCPRegistryCacheSecurity$Outbound = {
  Option1?: ClearMCPRegistryCacheSecurityOption1$Outbound | undefined;
  Option2?: ClearMCPRegistryCacheSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ClearMCPRegistryCacheSecurity$outboundSchema: z.ZodMiniType<
  ClearMCPRegistryCacheSecurity$Outbound,
  ClearMCPRegistryCacheSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ClearMCPRegistryCacheSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ClearMCPRegistryCacheSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function clearMCPRegistryCacheSecurityToJSON(
  clearMCPRegistryCacheSecurity: ClearMCPRegistryCacheSecurity,
): string {
  return JSON.stringify(
    ClearMCPRegistryCacheSecurity$outboundSchema.parse(
      clearMCPRegistryCacheSecurity,
    ),
  );
}

/** @internal */
export type ClearMCPRegistryCacheRequest$Outbound = {
  registry_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ClearMCPRegistryCacheRequest$outboundSchema: z.ZodMiniType<
  ClearMCPRegistryCacheRequest$Outbound,
  ClearMCPRegistryCacheRequest
> = z.pipe(
  z.object({
    registryId: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      registryId: "registry_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function clearMCPRegistryCacheRequestToJSON(
  clearMCPRegistryCacheRequest: ClearMCPRegistryCacheRequest,
): string {
  return JSON.stringify(
    ClearMCPRegistryCacheRequest$outboundSchema.parse(
      clearMCPRegistryCacheRequest,
    ),
  );
}
